module.exports = __webpack_public_path__ + "app/img/bac.5febffa5.jpg";